import React from 'react'
import d from '../../styles/Dashboard.module.css'
import s from '../../styles/Shared.module.css'
import { cf } from '../../utils'

const SettingsSwitch = ({ showAccount, setShowAccount, setView }) => {
	return (
		<div className={cf(s.flex, s.flexCenter, d.settingsSwitch)}>
			<div
				className={cf(
					s.wMax,
					s.flex,
					s.spaceXBetween,
					s.spaceYCenter,
					d.settingsSwitchBtn,
					s.pointer,
					showAccount ? d.selectedSettings : ''
				)}
				onClick={() => {
					setShowAccount((x) => true)
				}}
			>
				<div className={cf(s.flex, s.flexCenter, d.settingsSwitchInnerTag)}>
					<svg
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className={cf(s.flex, d.settingsSwitchIcon)}
					>
						<g id='user'>
							<path
								id='Icon'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M8.75 6C8.75 4.20507 10.2051 2.75 12 2.75C13.7949 2.75 15.25 4.20507 15.25 6C15.25 7.79493 13.7949 9.25 12 9.25C10.2051 9.25 8.75 7.79493 8.75 6ZM12 1.25C9.37665 1.25 7.25 3.37665 7.25 6C7.25 8.62335 9.37665 10.75 12 10.75C14.6234 10.75 16.75 8.62335 16.75 6C16.75 3.37665 14.6234 1.25 12 1.25ZM8.8 13.25C5.73482 13.25 3.25 15.7348 3.25 18.8C3.25 20.9815 5.01848 22.75 7.2 22.75H16.8C18.9815 22.75 20.75 20.9815 20.75 18.8C20.75 15.7348 18.2652 13.25 15.2 13.25H8.8ZM4.75 18.8C4.75 16.5632 6.56325 14.75 8.8 14.75H15.2C17.4368 14.75 19.25 16.5632 19.25 18.8C19.25 20.1531 18.1531 21.25 16.8 21.25H7.2C5.8469 21.25 4.75 20.1531 4.75 18.8Z'
								fill='#22272F'
							/>
						</g>
					</svg>
					<span className={cf(s.flex, d.settingsSwitchTag)}>Account</span>
				</div>
				{showAccount ? (
					<svg
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className={cf(d.settingsSwitchIcon)}
					>
						<g id='arrow-down'>
							<path
								id='Path 3'
								d='M10 18L16 12L10 6'
								stroke='#22272F'
								strokeLinecap='round'
							/>
						</g>
					</svg>
				) : (
					<></>
				)}
			</div>
			<div
				className={cf(
					s.wMax,
					s.flex,
					s.spaceXBetween,
					s.spaceYCenter,
					d.settingsSwitchBtn,
					s.pointer,
					!showAccount ? d.selectedSettings : ''
				)}
				onClick={() => {
					setView((x) => 'base')
					setShowAccount((x) => false)
				}}
			>
				<div className={cf(s.flex, s.flexCenter, d.settingsSwitchInnerTag)}>
					<svg
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className={cf(s.flex, d.settingsSwitchIcon)}
					>
						<g id='lock-2-opened'>
							<path
								id='Icon'
								fillRule='evenodd'
								clipRule='evenodd'
								d='M11.7679 1.25H11.8H15C16.5188 1.25 17.75 2.48122 17.75 4V4.5C17.75 4.91421 17.4142 5.25 17 5.25C16.5858 5.25 16.25 4.91421 16.25 4.5V4C16.25 3.30964 15.6904 2.75 15 2.75H11.8C10.9475 2.75 10.3533 2.75058 9.89068 2.78838C9.4368 2.82547 9.17604 2.8946 8.97852 2.99524C8.55516 3.21095 8.21095 3.55516 7.99524 3.97852C7.8946 4.17604 7.82546 4.43681 7.78838 4.89068C7.75058 5.35331 7.75 5.94755 7.75 6.8V7.2597C8.22605 7.24999 8.76171 7.25 9.36699 7.25H9.367H9.4H14.6H14.633H14.633H14.633C15.7252 7.24999 16.5907 7.24999 17.2883 7.30699C18.0017 7.36527 18.6053 7.48688 19.1565 7.76772C20.0502 8.22312 20.7769 8.94978 21.2323 9.84355C21.5131 10.3947 21.6347 10.9983 21.693 11.7117C21.75 12.4094 21.75 13.2748 21.75 14.367V14.4V15.6V15.633C21.75 16.7252 21.75 17.5906 21.693 18.2883C21.6347 19.0017 21.5131 19.6053 21.2323 20.1565C20.7769 21.0502 20.0502 21.7769 19.1565 22.2323C18.6053 22.5131 18.0017 22.6347 17.2883 22.693C16.5907 22.75 15.7252 22.75 14.6331 22.75H14.633H14.6H9.4H9.36698H9.36691C8.27481 22.75 7.40934 22.75 6.71173 22.693C5.99834 22.6347 5.39472 22.5131 4.84355 22.2323C3.94978 21.7769 3.22312 21.0502 2.76772 20.1565C2.48688 19.6053 2.36527 19.0017 2.30699 18.2883C2.24999 17.5906 2.24999 16.7251 2.25 15.633V15.6V14.4V14.367C2.24999 13.2749 2.24999 12.4094 2.30699 11.7117C2.36527 10.9983 2.48688 10.3947 2.76772 9.84355C3.22312 8.94978 3.94978 8.22312 4.84355 7.76772C5.27175 7.54954 5.73161 7.42746 6.25 7.35652V6.8L6.25 6.7679C6.24999 5.95506 6.24999 5.29944 6.29336 4.76853C6.33803 4.2219 6.43238 3.74175 6.65873 3.29754C7.01825 2.59193 7.59193 2.01825 8.29754 1.65873C8.74175 1.43239 9.2219 1.33803 9.76853 1.29336C10.2994 1.24999 10.9551 1.24999 11.7679 1.25H11.7679ZM6.83388 8.80201C6.21325 8.85271 5.829 8.94909 5.52453 9.10423C4.913 9.41582 4.41582 9.913 4.10423 10.5245C3.94909 10.829 3.85271 11.2133 3.80201 11.8339C3.75058 12.4633 3.75 13.2675 3.75 14.4V15.6C3.75 16.7325 3.75058 17.5367 3.80201 18.1661C3.85271 18.7867 3.94909 19.171 4.10423 19.4755C4.41582 20.087 4.913 20.5842 5.52453 20.8958C5.829 21.0509 6.21325 21.1473 6.83388 21.198C7.46326 21.2494 8.26752 21.25 9.4 21.25H14.6C15.7325 21.25 16.5367 21.2494 17.1661 21.198C17.7867 21.1473 18.171 21.0509 18.4755 20.8958C19.087 20.5842 19.5842 20.087 19.8958 19.4755C20.0509 19.171 20.1473 18.7867 20.198 18.1661C20.2494 17.5367 20.25 16.7325 20.25 15.6V14.4C20.25 13.2675 20.2494 12.4633 20.198 11.8339C20.1473 11.2133 20.0509 10.829 19.8958 10.5245C19.5842 9.913 19.087 9.41582 18.4755 9.10423C18.171 8.94909 17.7867 8.85271 17.1661 8.80201C16.5367 8.75058 15.7325 8.75 14.6 8.75H9.4C8.26752 8.75 7.46326 8.75058 6.83388 8.80201ZM12.75 14C12.75 13.5858 12.4142 13.25 12 13.25C11.5858 13.25 11.25 13.5858 11.25 14V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V14Z'
								fill='#515558'
							/>
						</g>
					</svg>
					<span className={cf(s.flex, d.settingsSwitchTag)}>
						Privacy and Security
					</span>
				</div>
				{!showAccount ? (
					<svg
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className={cf(d.settingsSwitchIcon)}
					>
						<g id='arrow-down'>
							<path
								id='Path 3'
								d='M10 18L16 12L10 6'
								stroke='#22272F'
								strokeLinecap='round'
							/>
						</g>
					</svg>
				) : (
					<></>
				)}
			</div>
		</div>
	)
}

export default SettingsSwitch
